export default __webpack_public_path__ + "static/media/ArrowRightIcon.a8ad3d76.svg";